/**
 * Where the API lives.
 *
 * Split out of `client.ts` — which it used to live at the bottom of — because a standalone
 * public page needs the same answer without the client that comes with it. Such a page is a
 * bundle deliberately kept to a few kilobytes (see `src/kiosk/`), and importing the
 * session-aware client for one string would have pulled the refresh machinery, the error
 * envelope and their dependencies into a page that has no session at all.
 *
 * `VITE_API_BASE_URL` points at the API origin and is baked in per environment at build time;
 * `/api/v1` is the version prefix every route sits behind. In development Vite also proxies
 * `/api`, so a relative base works when the variable is unset.
 */
const configuredApiOrigin = (import.meta.env['VITE_API_BASE_URL'] as string | undefined) ?? '';

export const API_ORIGIN = configuredApiOrigin.replace(/\/+$/, '');

export const API_BASE_URL = `${API_ORIGIN}/api/v1`;

/** Liveness probe, outside the version prefix — the connectivity detector pings it. */
export const API_HEALTH_URL = `${API_ORIGIN}/health`;
